/**
 * Text Render 对外发送的事件名称。
 */
export const Events = {
    /**
     * 某个宿主图层的 Text Render 结果已失效。
     */
    Invalidation: 'text-render/invalidation',
} as const;

/**
 * 文字引擎模拟斜体时使用的固定倾斜角度。
 */
export const ITALIC_SKEW_DEG = 14;

/**
 * Text Render 同时支持的最大可见描边层数。
 */
export const MAX_STROKE_COUNT = 3;

/**
 * 外发光宽度转换为 Alpha 扩张半径的比例
 */
export const GLOW_DILATE_RATIO = 0.25;

/**
 * 外发光宽度转换为模糊标准差的比例，对齐旧版轮廓发光
 */
export const GLOW_BLUR_SIGMA_RATIO = 0.8;

/**
 * 外发光最小模糊标准差，单位为 SVG 本地坐标像素
 */
export const GLOW_MIN_BLUR_SIGMA = 2;

/**
 * 阴影模糊量转换为滤镜标准差的比例
 */
export const SHADOW_BLUR_SIGMA_RATIO = 0.5;

/**
 * 预览和导出边界为阴影、外发光预留的模糊标准差倍数，即 3σ
 */
export const BLUR_EXTENT_SIGMAS = 3;
